//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        items: Array,
        nameFn: {
            type: Function,
            default: _.identity,
        },
    },
};
